interface RadioOption {
  value: string
  label: string
}

interface RadioGroupProps {
  options: RadioOption[]
  value: string | null
  onChange: (value: string) => void
  name: string
}

export function RadioGroup({ options, value, onChange, name }: RadioGroupProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const isSelected = value === option.value
        return (
          <label
            key={option.value}
            className={`
              inline-flex items-center px-3 py-1.5 text-sm font-medium cursor-pointer
              border rounded-full transition-colors
              ${isSelected
                ? 'bg-primary-text text-primary-bg border-primary-text'
                : 'bg-transparent text-secondary-text border-border hover:border-primary-text hover:text-primary-text'
              }
            `}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={isSelected}
              onChange={() => onChange(option.value)}
              className="sr-only"
            />
            {option.label}
          </label>
        )
      })}
    </div>
  )
}
